module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_right_white-bb3461edbf82e09e28c5b85ec6175a1a.svg";